<!-- Top Bar -->
<sbi-cot-back-main-top-bar> </sbi-cot-back-main-top-bar>

<!-- Page Container -->
<div class="private-page-container">
  <app-prime-loader *ngIf="loading$ | async"></app-prime-loader>
  <div *ngIf="!(loading$ | async)">
    <sbi-info-data-view-profile
      [viewProfileForm]="viewProfileForm"
    ></sbi-info-data-view-profile>
    <hr />
    <!-- Roles asignados -->
    <div>
      <h4>Roles asignados</h4>
      <p class="data-3-span">
        Roles que determinan las responsabilidades del usuario.
      </p>
      <div class="role-list">
        <div
          *ngFor="let role of viewProfileForm.get('roles')?.value"
          class="role-item"
        >
          <p>{{ role }}</p>
        </div>
      </div>
    </div>

    <hr />
    <!-- Permisos -->
    <div>
      <h4>Permisos asignados</h4>
      <p class="data-3-span">
        Accesos y acciones habilitadas por cada rol asignado.
      </p>
    </div>

    <p-tabs [value]="orderedPermissionsForDetail?.[0]?.portal">
      <p-tablist>
        <p-tab
          *ngFor="let portal of orderedPermissionsForDetail"
          [value]="portal.portal"
        >{{ getPortalName(portal.portal) }}</p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel
          *ngFor="let portal of orderedPermissionsForDetail"
          [value]="portal.portal"
        >
          <p-accordion *ngFor="let module of portal.modules" [multiple]="true">
            <p-accordion-panel [value]="module.module">
              <p-accordion-header>{{ module.module }}</p-accordion-header>
              <p-accordion-content>
                <div class="body-container">
                  <ul>
                    <ng-container
                      *ngFor="let permission of module.permissions; let i = index"
                    >
                      <li class="flex items-center">
                        <div class="input-check">
                          <label class="ml-2">{{ permission.name }}</label>
                        </div>
                      </li>
                    </ng-container>
                  </ul>
                </div>
              </p-accordion-content>
            </p-accordion-panel>
          </p-accordion>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>
</div>
